import React from "react"
import { styled } from "@mui/material/styles"
import { css } from '@emotion/react';

import {
  FormControlLabel,
  Switch,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material"
import { inject, observer } from "mobx-react"

const EditCollectionFormContainer = styled('div')``

const EditCollectionSubmitRow = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`

const EditCollectionFields = styled('div')``

const CollectionImage = styled('img')`
  height: 160px;
`

const DeleteButton = styled(Button)`
  font-size: 16px;
  margin-right: 15px;
  color: #ed3c3c;
`

const SFTextField = styled(TextField)`
  .MuiInputBase-root {
    font-family: Lato;
  }
`
const MuiStyleLabel = styled('label')``

const MuiStyleHelperText = styled('div')``

const MuiStyleInputBorder = styled('div')``

const MuiStyleInputContainer = styled('div')`
  position: relative;
  margin-top: 12px;

  ${MuiStyleInputBorder} {
    border: 1px solid rgba(0, 0, 0, 0.23);
    padding: 20px;
    border-radius: 4px;
    min-height: 55px;
    display: flex;
    align-items: center;
    border-color: ${(props) => (props.error ? "red" : "rgba(0, 0, 0, 0.23)")};
  }

  ${MuiStyleHelperText} {
    font-size: 0.75rem;
    margin: 3px 14px;
    color: ${(props) => (props.error ? "red" : "rgba(0, 0, 0, 0.54)")};
  }

  ${MuiStyleLabel} {
    transform: translate(3px, -12px) scale(0.75);
    font-size: 16px;
    color: ${(props) => (props.error ? "red" : "rgba(0, 0, 0, 0.54)")};
    position: absolute;
    background-color: ${(props) => (props.isSelected ? "whitesmoke" : "white")};
    padding: 0 6px;
  }
`

@inject("collectionStore", "userStore", "snackbarStore")
@observer
export default class EditCollectionForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      coverImageURL: props.imageUrl,
      didSave: false,
    }
  }

  static defaultProps = {
    handleAccordionChange: () => {},
  }

  handleFileInputChange = (e) => {
    this.setState({
      coverImageFile: e.target.files[0],
      coverImageUrl: URL.createObjectURL(e.target.files[0]),
    })
  }

  handleNameInputChange = (e) => {
    const { collectionStore } = this.props
    const collection = collectionStore.focusedCollection
    collection.name = e.target.value
  }

  handleInputTouched = (e) => {
    const { collectionStore } = this.props
    const collection = collectionStore.focusedCollection
    collection.touchField(e.target.name)
  }

  handleCreateClick = async () => {
    const { collectionStore, handleAccordionChange, snackbarStore } = this.props
    const { coverImageFile } = this.state

    const collection = collectionStore.focusedCollection

    collection.touchAllFields()
    if (coverImageFile) {
      collection.newImageFile = coverImageFile
    }
    this.setState({ isSubmitting: true })

    try {
      let response
      if (collection.isPersisted) {
        response = await collection.update()
      } else {
        response = await collection.create({ setToSampleOwner: true })
      }
      if (response != false) {
        this.setState({ didSave: true, isSubmitting: false })
        handleAccordionChange()
        snackbarStore.showSnackbar("Success!", "success")
      } else {
        this.setState({ isSubmitting: false })
      }
    } catch (error) {
      console.error("Error creating collection", error)
      snackbarStore.showSnackbar(
        `Something went wrong: ${error.response.data.errors.join(" ")}`,
        "error"
      )
      this.setState({ didSave: false, isSubmitting: false })
    }
  }

  handlePublishChange = (e) => {
    const { collectionStore } = this.props
    const collection = collectionStore.focusedCollection
    const isChecked = e.target.checked
    collection.setIfPublished(isChecked)
  }

  handleDeleteClick = async () => {
    if (
      window.confirm(
        "Are you sure you want to delete this collection? This will not delete the associated samples."
      )
    ) {
      const { collectionStore } = this.props
      const collection = collectionStore.focusedCollection
      await collection.delete()
    }
  }

  render() {
    const { collectionStore, userStore } = this.props
    const { coverImageUrl, isSubmitting, didSave } = this.state
    const collection = collectionStore.focusedCollection
    const isPublished = collection.allSamplesPublished
    const currentUser = userStore.currentUser
    return (
      <EditCollectionFormContainer>
        <EditCollectionFields>
          <SFTextField
            id="collection-name"
            label="Collection name"
            name="name"
            inputProps={{
              className: 'browser-default',
            }}
            InputLabelProps={{
              shrink: true,
            }}
            helperText={
              Boolean(
                collection.touchedFields.name &&
                  collection.validationErrors.name
              )
                ? "Required."
                : ""
            }
            variant="outlined"
            fullWidth
            style={{ marginRight: 10 }}
            onChange={this.handleNameInputChange}
            onBlur={this.handleInputTouched}
            value={collection.name}
            autoComplete="off"
            error={Boolean(
              collection.touchedFields.name && collection.validationErrors.name
            )}
            required
            aria-label="Collection name input"
          />
          <MuiStyleInputContainer>
            <MuiStyleLabel>Cover image</MuiStyleLabel>
            <MuiStyleInputBorder>
              <div>
                {coverImageUrl && <CollectionImage src={coverImageUrl} />}
                <p>Please upload a custom GIF or JPEG image</p>
                <input
                  as="file"
                  type="file"
                  name="collection[image]"
                  id="collection_image"
                  onChange={this.handleFileInputChange}
                  accept="image/jpeg, image/jpg, image/gif"
                  aria-label="Upload collection image"
                />
                <div
                  css={css`
                    font-size: 12px;
                    color: grey;
                    margin-top: 8px;
                  `}
                >
                  <em>
                    GIF, JPEG, or PNG format. 768x618 recommended. Max 1.0 mb.
                  </em>
                </div>
              </div>
            </MuiStyleInputBorder>
          </MuiStyleInputContainer>
        </EditCollectionFields>
        {Boolean(collection.validationErrors.multipleUsers) && (
          <p
            css={css`
              color: red;
              margin: 2px 0;
            `}
          >
            Cannot create a collection associated with multiple users.
          </p>
        )}
        <EditCollectionSubmitRow>
          {collection.isPersisted && (
            <DeleteButton color="secondary" onClick={this.handleDeleteClick} aria-label="Delete collection">
              <i className="far fa-trash-can" aria-hidden="true"></i>
            </DeleteButton>
          )}
          {collection.isPersisted && currentUser.canModerate && (
            <FormControlLabel
              control={
                <Switch
                  checked={isPublished}
                  onChange={this.handlePublishChange}
                  name="publish"
                  color="primary"
                  aria-label="Publish/unpublish switch"
                  />
                }
              label="Publish"
            />
          )}
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleCreateClick}
            disabled={isSubmitting}
            aria-label={`${isSubmitting ? "Submitting" : collection.isPersisted ? "Update" : "Create Collection"}`}
          >
            {isSubmitting
              ? "Submitting"
              : collection.isPersisted
              ? "Update"
              : "Create Collection"}
            {isSubmitting && (
              <CircularProgress
                css={css`
                  margin-left: 8px;
                `}
                size={24}
              />
            )}
          </Button>
        </EditCollectionSubmitRow>
      </EditCollectionFormContainer>
    )
  }
}
